import { render, staticRenderFns } from "./configurator-loader.vue?vue&type=template&id=30c18e50&scoped=true&"
import script from "./configurator-loader.vue?vue&type=script&lang=js&"
export * from "./configurator-loader.vue?vue&type=script&lang=js&"
import style0 from "./configurator-loader.vue?vue&type=style&index=0&id=30c18e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c18e50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30c18e50')) {
      api.createRecord('30c18e50', component.options)
    } else {
      api.reload('30c18e50', component.options)
    }
    module.hot.accept("./configurator-loader.vue?vue&type=template&id=30c18e50&scoped=true&", function () {
      api.rerender('30c18e50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/configurator/configurator-loader.vue"
export default component.exports